<div class="title" #title>
  <div class="container container-max-width">
    <div>
      <h4>Blueprints</h4>
      <p>View all onboarded capacity blueprints</p>
    </div>
    <div class="action-container">
      <button type="button" *ngIf="isAdminUser" class="btn btn-primary" style="margin-left: 8px;"
        (click)="refresh()">
        Refresh
      </button>
      <button type="button" *ngIf="isAdminUser" class="btn btn-primary" style="margin-left: 8px;"
        (click)="fullRefresh()">
        Full Refresh
      </button>
      <a
        href="javascript:void(0)"
        class="topbar-item"
        (click)="exportExcel()"
        placement="top-right"
        container="body"
        ngbTooltip="Export to Excel"
        aria-label="Export to Excel">
        <span class="far fa-file-excel fa-lg"></span>
      </a>
    </div>
  </div>
</div>
<div class="container container-content container-max-width" (window:resize)="onResize()" [style.height]="containerHeight">
  <div class="landing-main mt-3">
    <grid-filter-pills [gridApi]="gridApi" *ngIf="gridApi"></grid-filter-pills>
    <ag-grid-angular
      #agGrid
      id="ViewGrid"
      style="width: 100%; height: 540px"
      class="ag-theme-balham"
      [masterDetail]="true"
      [gridOptions]="gridOptions"
      [excelStyles]="headerStyle"
      [rowData]="rowData"
      [pagination]="true"
      (gridReady)="onGridReady($event)"
      (filterChanged)="onFilterChanged($event)">
    </ag-grid-angular>
  </div>
</div>
